import { useEffect } from 'react';
import { useIntl } from 'react-intl';

import { ContentContainer } from '~/eds/src/components/ContentContainer/ContentContainer';
import { api } from '~/redux/api/createApi';
import { RoutePathType } from '~/routing/enums';
import { useRouting } from '~/routing/useRouting';

export default function TicketRedirect() {
  const intl = useIntl();
  const { navigate, getSearchParam } = useRouting();
  const contractRecordUniqueId = getSearchParam(
    'contract_record_unique_id',
    '',
  );
  const wssContractId = getSearchParam('wss_contract_id', '');
  const hasIdentifier = Boolean(contractRecordUniqueId || wssContractId);
  const {
    data: resolvedTicket,
    isError,
    isLoading,
  } = api.endpoints.resolveWssTicketId.useQuery(
    {
      contractRecordUniqueId: contractRecordUniqueId || undefined,
      wssContractId: wssContractId || undefined,
    },
    { skip: !hasIdentifier },
  );
  const [
    resolveDocument,
    { isError: isDocumentError, isLoading: isDocumentLoading },
  ] = api.endpoints.resolveWssDocument.useLazyQuery();

  useEffect(() => {
    if (resolvedTicket) {
      if (!resolvedTicket.isCompleted) {
        navigate(
          RoutePathType.WorkflowTicketsTicket.replace(
            ':ticketId',
            resolvedTicket.ticketId,
          ),
          { replace: true },
        );
      } else {
        // Redirect to the document associated with the resolved ticket
        resolveDocument({
          contractRecordUniqueId: contractRecordUniqueId || undefined,
          wssContractId: wssContractId || undefined,
        })
          .unwrap()
          .then((response) => {
            if (response?.documentId) {
              navigate(
                RoutePathType.Document.replace(
                  ':documentId',
                  `${response.documentId}`,
                ),
                {
                  replace: true,
                },
              );
            } else {
              // Handle case where no document is found
              navigate('/documents');
            }
          });
      }
    }
  }, [resolvedTicket]);

  const placeholderContent =
    isError || isDocumentError || !hasIdentifier
      ? {
          image: 'error-page-not-found',
          title: intl.formatMessage({
            id: 'ContractPage.ticketNotFoundTitle',
            defaultMessage: 'Ticket Not Found',
            description: 'Title for when a ticket cannot be found',
          }),
          description: intl.formatMessage({
            id: 'ContractPage.ticketNotFoundDescription',
            defaultMessage:
              'The associated ticket could not be found. It may have been deleted or does not exist.',
            description: 'Description explaining why a ticket was not found',
          }),
        }
      : undefined;

  return (
    <ContentContainer
      placeholderContent={placeholderContent}
      loadingContent={{ isLoading: isLoading || isDocumentLoading }}
    >
      <></>
    </ContentContainer>
  );
}
